/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LicensingModule
 */

/**
 * Connectivity status constants.
 */
export const CONNECTIVITY_STATUS = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
};

export const DEPLOYING_LICENSE_HUB_KB_URL = 'https://kb.broadcom.com/s/article/XXXXX';
export const REGISTERING_LICENSE_HUB_KB_URL = 'https://kb.broadcom.com/s/article/XXXXX';
export const PULSE_LICENSES_URL = 'https://portal.pulse.broadcom.com/license-management/licenses';
export const BROADCOM_ENTITLEMENTS_URL = 'https://support.broadcom.com/group/ecx/products';
export const ENDPOINT_MANAGEMENT_KB_URL = 'https://kb.broadcom.com/s/article/XXXXX';
export const USAGE_REPORT_KB_URL = 'https://kb.broadcom.com/s/article/XXXXX';
export const KB_ARTICLE_URL = 'https://kb.broadcom.com/s/article/XXXXX';

// eslint-disable-next-line max-len
export const AVI_LOAD_BALANCER_LICENSING_GUIDE = 'https://techdocs.broadcom.com/us/en/vmware-security-load-balancing/avi-load-balancer/avi-load-balancer/32-1/vmware-avi-load-balancer-licensing-guide.html';
